import MarketingService from '@/services/marketing-service'
import store from '@/store'
import adminNavItems from '@/navigation/vertical/admin/index'
import { getFirstAccessibleSubuserRoute } from '@/utils/permissions-helper'

export default function () {
  const pendingRoute = MarketingService.getPendingRoute()
  if (pendingRoute) return pendingRoute

  if (store.getters['auth/isAuthenticated'] && !store.getters['permissions/isPrimaryAccount']) {
    const firstRoute = getFirstAccessibleSubuserRoute(
      store.getters['permissions/hasAnySubuserPermission'],
      adminNavItems as any[],
    )
    if (firstRoute) return firstRoute
  }

  return { name: 'admin:dashboard' }
}
